import API_CONSTANT from 'constants/apiConstant';
import { Get } from 'utils/Request';
import { GetRequest, PostRequest } from './Request';
import { getRequest, deleteRequest, putRequest, postRequest } from './RequestV2';
import { get } from 'utils/RequestV2';
import { get as jarvisGet } from '../../CashbackRewardsFlow/Services/Request';
import store from 'redux/store';

export const validateCreditCardNumber = async (payload) =>
	GetRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_VALIDATE, payload);

export const getBankDetails = () => GetRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_BANK_DETAILS);

export const getCreditCardsList = async () => getRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_LIST);
export const getTransactionsList = async (param) =>
	getRequest('v2' + API_CONSTANT.URL.CREDIT_CARD_PAYMENT_LIST, { category: 'CREDIT_CARD_BILL', lastDigits: param });
export const getTransactionDetail = async (payload) => getRequest('v2' + API_CONSTANT.URL.CREDIT_CARD_ORDER, payload);

export const postCardInitiatePayment = async (payload) =>
	PostRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_INITIATE_PAYMENT, payload);

export const getTransactionFulfillDetail = async (payload) =>
	PostRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_ORDER_FULFILL, payload);

export const getPostpePaymentModes = async () => get('v1' + API_CONSTANT.URL.POSTPE_PAYMENT_MODES);

export const deleteCard = async (payload) => putRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_LIST, payload);

export const updateCardPriority = async (payload) => putRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_LIST, payload);

export const cardHistory = async (param) =>
	getRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_HISTORY + '?lastDigits=' + param);

export const createOrder = async (payload) => postRequest('v1' + API_CONSTANT.URL.CREDIT_CARD_CREATE_ORDER, payload);

export const checkOrderStatus = async (payload) => postRequest('v1' + API_CONSTANT.URL.CHECK_ORDER_STATUS, payload);

export const cashbackRewardsList = async () => jarvisGet(API_CONSTANT.URL.TXN_CASHBACK_DETAILS);

export const slicedCashbackRewardsList = async () =>
	jarvisGet(API_CONSTANT.URL.TXN_CASHBACK_DETAILS + API_CONSTANT.QUERY_PARAMS.LIMIT + '3');

export const getTxnCashbackStatus = async (param) =>
	jarvisGet(API_CONSTANT.URL.TXN_CASHBACK_DETAILS + '&txnId=' + param);

export const checkCardExpiry = (cardId) => getRequest('v1' + `${API_CONSTANT.URL.CCBP_CARD_EXPIRY}?cardId=${cardId}`);

export const getSuggestedVAS = async (payload) => {
	let resp = [];
	const vasEnable = store.getState()?.featureAccess?.VAS?.enabled;
	if (vasEnable === true) resp = await getRequest('v1' + API_CONSTANT.URL.VAS_PRODUCT, payload);
	return resp;
};
